<script>
  import Table from "./Table.svelte";
  import Party from "./Party.svelte";
  import dayjs from "dayjs";
  import utc from "dayjs/plugin/utc";
  import relativeTime from "dayjs/plugin/relativeTime";
  dayjs.extend(utc);
  dayjs.extend(relativeTime);

  // cards, donor, exp, fame, guild, job, level, name, quests, timestamp
  const columns = [
    {
      name: "last update (server time)",
      format: (row) => dayjs.utc(row.timestamp).format(),
    },
    {
      name: "last update (relative)",
      format: (row) =>
        dayjs.utc(row.timestamp).subtract(5, "seconds").fromNow(),
    },
    { name: "name", format: (row) => row.name },
    { name: "level", format: (row) => row.level },
    { name: "exp", format: (row) => row.exp },
  ];

  let data = [];
  let players;
  let requests = 0;

  let is_valid;
  // This will continue to run forever if running is not assigned. We should
  // clear this flag whenever we want to make a new request.

  let is_monitoring = false;
  let should_fetch = false;

  let update_interval = 60;
  let last_update_seconds = 0;
  let interval;

  $: !is_monitoring && interval && clearInterval(interval);
  $: last_update_seconds > update_interval &&
    (should_fetch = true) &&
    (last_update_seconds = 0);

  $: is_valid &&
    should_fetch &&
    players.map((name) => {
      fetch(
        // this proxies https://maplelegends.com/api/
        `https://us-west2-geospiza.cloudfunctions.net/character?name=${name}`
      ).then((resp) =>
        resp.json().then((row) => {
          requests += 1;
          // check if we should update based on the character name
          let last_row = data.filter((row) => row.name == row.name);
          if (!last_row.length || last_row[0].exp != row.exp) {
            data = [row, ...data];
          }
        })
      );
    }) &&
    (should_fetch = false);
</script>

<main>
  <h1>Experience Tracker</h1>
  <b>[Work in progress]</b>
  <p>
    A web application to track experience over a playing session. Data updates
    on channel changes, teleports between maps, and changing channels.
  </p>

  <p>
    This uses the same API as the Discord bot (proxied through a cloud function
    to circumvent CORS issues). Find the source code
    <a
      href="https://bitbucket.org/geospiza/geospiza.me/src/main/apps/ml-exp-tracker"
    >
      on Bitbucket.
    </a>
    Written by
    <a href="https://geospiza.me/">geospiza.</a>
  </p>

  <h2>Party</h2>

  <Party bind:players bind:is_valid disabled={is_monitoring} />

  <h2>Data</h2>

  {#if is_valid}
    <div>
      {#if !is_monitoring}
        <button
          on:click={() => {
            is_monitoring = !is_monitoring;
            should_fetch = true;
            last_update_seconds = 0;
            interval = setInterval(() => {
              last_update_seconds += 0.1;
            }, 100);
          }}
        >
          start monitoring
        </button>
      {:else}
        <button on:click={() => (is_monitoring = !is_monitoring)}>
          stop monitoring
        </button>
        Next update in {(update_interval - last_update_seconds).toFixed(1)} seconds.
      {/if}
    </div>
  {:else}
    <p>Party is not valid.</p>
  {/if}

  <p>{requests} API requests made so far.</p>

  {#if data.length > 0}
    <Table {data} {columns} />
  {/if}
</main>

<style>
  main {
    color: #333;
    margin: 0 auto;
    max-width: 800px;
    margin-bottom: 2em;
    box-sizing: border-box;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
      Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  }
</style>
